
import { Vue, Component } from 'vue-property-decorator'
import { backToBefore } from '@/utils/h5ToApp'

@Component
export default class DataReport extends Vue {
  list = [
    {
      title: '客户订货',
      icon: 'icon-paihang1',
      link: '/orderReport',
      limit: 'orderReport'
    },
    {
      title: '商品销售',
      icon: 'icon-a-paihang2',
      link: '/saleReport',
      limit: 'saleReport'
    },
    {
      title: '地区统计',
      icon: 'icon-a-paihang3',
      link: '/areaReport',
      limit: 'areaReport'
    },
    {
      title: '员工拉新',
      icon: 'icon-a-paihang4',
      link: '/employeeNew',
      limit: 'employeeNew'
    },
    {
      title: '员工业绩',
      icon: 'icon-a-paihang5',
      link: '/employeeKpi',
      limit: 'employeeKpi'
    },
    {
      title: '订单监控',
      icon: 'icon-a-paihang6',
      link: '/orderMonitor',
      limit: 'orderMonitor'
    },
    {
      title: '订单商品统计',
      icon: 'icon-a-paihang7',
      link: '/goodsOrder',
      limit: 'goodsOrder'
    },
    {
      title: '退单商品统计',
      icon: 'icon-a-paihang8',
      link: '/returnGoodsOrder',
      limit: 'returnGoodsOrder'
    },
  ]

  toLink (link: string, limit: string) {
    // if (!this.$action(limit)) {
    //   return false
    // }
    this.$router.push(link)
  }
}
